"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitDateUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var components_1 = require("../../../components");
var copy_1 = require("../../../copy");
var data_1 = require("../../../data");
var section_ids_1 = require("../../../section-ids");
var utils_1 = require("../../../utils");
var ChangeDirectDebitDateUI = function (_a) {
    var _b;
    var _c, _d, _e, _f;
    var paymentDetails = _a.paymentDetails, customerId = _a.customerId, accountId = _a.accountId, apiErrorCode = _a.apiErrorCode;
    var _g = __read((0, react_1.useState)(false), 2), apiError = _g[0], setApiError = _g[1];
    var _h = __read((0, react_1.useState)(paymentDetails ? (_c = paymentDetails.paymentSchedule) === null || _c === void 0 ? void 0 : _c.scheduleDay : undefined), 2), dayOfMonth = _h[0], setDayOfMonth = _h[1];
    var _j = (0, core_1.useLinks)(), updateDirectDebitDateConfirmation = _j.updateDirectDebitDateConfirmation, payments = _j.payments;
    var errorRef = (0, react_1.createRef)();
    var navigate = (0, ui_tools_1.useNavigate)();
    var _k = (0, data_1.useChangePaymentDate)({
        customerId: customerId,
        accountId: accountId,
    }), directDebitDateMutation = _k.mutate, loading = _k.loading;
    (0, react_1.useEffect)(function () {
        // Focus error message when it appears.
        if (apiError && errorRef.current) {
            errorRef.current.focus();
        }
        // Excluding ref from dependency array prevents repeated focus.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiError]);
    var handleDayOfMonthChange = function (_a) {
        var value = _a.currentTarget.value;
        setDayOfMonth(Number(value));
    };
    var handleSubmit = function (event) {
        var _a;
        event.preventDefault();
        if (loading) {
            return;
        }
        setApiError(false);
        dayOfMonth &&
            directDebitDateMutation({
                scheduleDay: dayOfMonth,
                paymentScheduleId: paymentDetails
                    ? (_a = paymentDetails.paymentSchedule) === null || _a === void 0 ? void 0 : _a.id
                    : undefined,
            }, {
                onCompleted: function (_a) {
                    var _b, _c;
                    var nextPaymentChargeDate = _a.nextPaymentChargeDate;
                    screen_reader_route_manager_1.default.beforeRouteChange();
                    var nextPaymentDate = nextPaymentChargeDate &&
                        new Date(nextPaymentChargeDate) > new Date()
                        ? nextPaymentChargeDate
                        : (0, utils_1.getNextInstanceOfScheduleDay)(dayOfMonth);
                    var oneTimePaymentPrompt = (0, utils_1.showOneTimePaymentPrompt)(dayOfMonth, paymentDetails
                        ? (_b = paymentDetails.paymentSchedule) === null || _b === void 0 ? void 0 : _b.scheduleDay
                        : undefined);
                    navigate({
                        pathname: updateDirectDebitDateConfirmation(),
                        search: "?nextPaymentDate=".concat(nextPaymentDate, "&amount=").concat((_c = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _c === void 0 ? void 0 : _c.amount, "&oneTimePaymentPrompt=").concat(oneTimePaymentPrompt),
                    });
                },
                onError: function () {
                    setApiError(true);
                },
            });
    };
    var _l = (0, core_1.useComponents)(), PrimaryCTAButton = _l.PrimaryCTAButton, SelectField = _l.SelectField, Stack = _l.Stack, PageLayout = _l.PageLayout, ButtonGroup = _l.ButtonGroup, ErrorNotification = _l.ErrorNotification;
    var _m = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _m.Copy, copy = _m.copy;
    var errorCode = apiErrorCode || (0, utils_1.getErrorCode)(paymentDetails);
    return (react_1.default.createElement("section", { id: section_ids_1.CHANGE_DD_DATE_SECTION_ID, "data-testid": section_ids_1.CHANGE_DD_DATE_SECTION_ID },
        apiError ? (react_1.default.createElement(ErrorNotification, { id: section_ids_1.CHANGE_DIRECT_DEBIT_DATE_SUBMIT_ERROR, ref: errorRef },
            react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateErrorGeneric" }))) : null,
        react_1.default.createElement(PageLayout, { pageId: section_ids_1.CHANGE_DD_DATE_SECTION_ID, heading: react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateHeading" }), backLink: payments(), backLinkLabel: react_1.default.createElement(Copy, { copyKey: "backtoPaymentsBreadcrumb" }) },
            react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                react_1.default.createElement("div", null, ((_d = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _d === void 0 ? void 0 : _d.method) &&
                    ((_e = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.paymentSchedule) === null || _e === void 0 ? void 0 : _e.day) &&
                    ((_f = paymentDetails.paymentSchedule) === null || _f === void 0 ? void 0 : _f.digits) && (react_1.default.createElement(Copy, { copyKey: paymentDetails.paymentSchedule.method === 'CARD'
                        ? 'regularPaymentSummaryCardBody'
                        : 'regularPaymentSummaryBankBody', values: {
                        amount: (0, core_1.major2DP)((0, core_1.majorToMinor)(paymentDetails.paymentSchedule.amount)),
                        day: (0, utils_1.withOrdinal)(paymentDetails.paymentSchedule.day),
                        digits: paymentDetails.paymentSchedule.digits,
                    } }))),
                errorCode ? (react_1.default.createElement(components_1.ErrorState, { error: errorCode, type: "Date" })) : (react_1.default.createElement("form", { onSubmit: handleSubmit, noValidate: true },
                    react_1.default.createElement(Stack, { spaceBetween: [3, 6] },
                        react_1.default.createElement(SelectField, { id: "payment-date", "data-testid": "payment-date", label: copy('updateDirectDebitDateDayLabel'), hint: copy('updateDirectDebitDateDayHint'), characters: 6, value: dayOfMonth, onChange: handleDayOfMonthChange },
                            react_1.default.createElement(components_1.DateSelectOptions, null)),
                        react_1.default.createElement(ButtonGroup, null,
                            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.AMEND_DD_DATE_SUBMIT, properties: (_b = {
                                        selectedDayOfMonth: dayOfMonth
                                    },
                                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                                    _b) },
                                react_1.default.createElement(PrimaryCTAButton, { "data-testid": "change-dd-date-button", type: "submit", loading: loading },
                                    react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateSubmit" })))))))))));
};
exports.ChangeDirectDebitDateUI = ChangeDirectDebitDateUI;
